import { homeSecurityPortalApi } from 'data/axios';
import { TPlanList } from 'typings';
import { ApiResponse } from './HttpRequest';
import { endpoints } from './endpoints';

export async function getPlanDetails(
  country: string
): Promise<ApiResponse<TPlanList[]>> {
  const response = await homeSecurityPortalApi.get(endpoints.plansUrl(country));
  return response;
}
